import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import QRCode from 'qrcode';
import { THEME } from '../../styles/theme';

export default function WifiConnect() {
  const [open,    setOpen]    = useState(false);
  const [url,     setUrl]     = useState('');
  const [copied,  setCopied]  = useState(false);
  const [loading, setLoading] = useState(false);
  const canvasRef = useRef(null);

  const fetchIP = async () => {
    setLoading(true);
    try {
      const res  = await fetch('/api/localip');
      const data = await res.json();
      setUrl(data.url);
    } catch {
      setUrl('http://localhost:3001');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!url || !canvasRef.current) return;
    QRCode.toCanvas(canvasRef.current, url, {
      width:  200,
      margin: 2,
      color:  { dark: '#0a0f1e', light: '#e2e8f0' },
    });
  }, [url, open]);

  const handleOpen = () => { setOpen(true); fetchIP(); };
  const handleClose = () => setOpen(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(url).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  // Render modal via Portal so it's always relative to viewport (bypasses parent transforms)
  const modal = open ? ReactDOM.createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}
      style={{
        position:        'fixed',
        top:             0,
        left:            0,
        width:           '100vw',
        height:          '100vh',
        zIndex:          999999,
        background:      'rgba(0,0,0,0.82)',
        backdropFilter:  'blur(10px)',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        padding:         '20px',
        boxSizing:       'border-box',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background:    '#0d1520',
          border:        '1px solid rgba(0,212,255,0.3)',
          borderRadius:  '20px',
          padding:       '28px 24px 24px',
          width:         '340px',
          maxWidth:      '100%',
          maxHeight:     '90vh',
          overflowY:     'auto',
          textAlign:     'center',
          position:      'relative',
          boxSizing:     'border-box',
        }}
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          style={{
            position:   'absolute',
            top:        '14px',
            right:      '14px',
            background: 'rgba(255,255,255,0.08)',
            border:     '1px solid rgba(255,255,255,0.15)',
            borderRadius: '50%',
            width:      '28px',
            height:     '28px',
            color:      'rgba(255,255,255,0.7)',
            fontSize:   '14px',
            cursor:     'pointer',
            display:    'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
          }}
        >
          ✕
        </button>

        {/* Title */}
        <div style={{ fontSize: '16px', fontWeight: '800', color: THEME.colors.blue, letterSpacing: '2px', marginBottom: '2px' }}>
          📱 MOBILE CONNECT
        </div>
        <div style={{ fontSize: '11px', color: THEME.colors.textMuted, marginBottom: '20px' }}>
          Phone ने QR scan करा — JARVIS उघडेल
        </div>

        {/* QR Canvas */}
        <div style={{
          display:         'flex',
          alignItems:      'center',
          justifyContent:  'center',
          background:      '#e2e8f0',
          borderRadius:    '12px',
          padding:         '10px',
          marginBottom:    '16px',
        }}>
          {loading
            ? <div style={{ width: 200, height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#555', fontSize: '13px' }}>Loading...</div>
            : <canvas ref={canvasRef} style={{ borderRadius: '6px', display: 'block' }} />
          }
        </div>

        {/* Steps */}
        <div style={{ textAlign: 'left', marginBottom: '16px' }}>
          {[
            'Phone आणि PC एकाच WiFi वर असणे आवश्यक',
            'Camera app उघडा → QR code वर point करा',
            'Link दिसेल → tap करा → JARVIS उघडेल',
          ].map((step, i) => (
            <div key={i} style={{ display: 'flex', gap: '8px', padding: '3px 0', fontSize: '12px', color: 'rgba(148,163,184,0.85)' }}>
              <span style={{ color: THEME.colors.blue, flexShrink: 0 }}>{i + 1}.</span>
              <span>{step}</span>
            </div>
          ))}
        </div>

        {/* URL + copy */}
        <div style={{
          background:      'rgba(0,0,0,0.4)',
          border:          '1px solid rgba(0,212,255,0.15)',
          borderRadius:    '8px',
          padding:         '9px 12px',
          display:         'flex',
          alignItems:      'center',
          justifyContent:  'space-between',
          gap:             '8px',
          marginBottom:    '12px',
        }}>
          <code style={{ fontSize: '13px', color: THEME.colors.green, fontFamily: 'monospace', wordBreak: 'break-all' }}>
            {url || 'Fetching...'}
          </code>
          <button
            onClick={handleCopy}
            title="Copy URL"
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: copied ? THEME.colors.green : THEME.colors.textMuted,
              fontSize: '16px', flexShrink: 0,
            }}
          >
            {copied ? '✓' : '⎘'}
          </button>
        </div>

        {/* Refresh + Close row */}
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={fetchIP}
            style={{
              flex: 1, background: 'none',
              border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px',
              color: THEME.colors.textMuted, fontSize: '12px',
              padding: '7px 10px', cursor: 'pointer',
            }}
          >
            🔄 Refresh IP
          </button>
          <button
            onClick={handleClose}
            style={{
              flex: 1, background: 'rgba(239,68,68,0.08)',
              border: '1px solid rgba(239,68,68,0.2)', borderRadius: '8px',
              color: '#f87171', fontSize: '12px',
              padding: '7px 10px', cursor: 'pointer',
            }}
          >
            ✕ बंद करा
          </button>
        </div>
      </div>
    </div>,
    document.body
  ) : null;

  return (
    <>
      <button
        onClick={handleOpen}
        title="Connect mobile via WiFi"
        style={{
          background:   'rgba(0,212,255,0.08)',
          border:       '1px solid rgba(0,212,255,0.2)',
          borderRadius: '8px',
          color:        THEME.colors.blue,
          fontSize:     '13px',
          fontWeight:   '600',
          padding:      '6px 12px',
          cursor:       'pointer',
          display:      'flex',
          alignItems:   'center',
          gap:          '6px',
          whiteSpace:   'nowrap',
        }}
      >
        📱 WiFi Connect
      </button>
      {modal}
    </>
  );
}
